<template>
  <div @click="goBack">
    <el-container>
      <el-header>
        <my-header @goBack="goBack" ref="myHeader"></my-header>
      </el-header>
      <el-main>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <el-footer>
        <my-footer @goTopSearch="goTopSearch" ref="myFooter"></my-footer>
      </el-footer>
    </el-container>
  </div>

</template>

<script>
  import MyHeader from '../components/header'
  import MyFooter from '../components/footer'
  export default {
      name: "home",
      components: {
        MyHeader,
        MyFooter
      },
      methods:{
        goBack(){
          if (this.$refs.myFooter) {
            this.$refs.myFooter.isLaw = false;
            this.$refs.myFooter.isSupport = false;
          }
        },
        goTopSearch(){
          this.$refs.myHeader.$refs.isFocus.focus();
          this.$refs.myFooter.isSupport = false;
        }
      }
    }
</script>

<style scoped>
  @import url("//unpkg.com/element-ui@2.4.10/lib/theme-chalk/index.css");
  .el-header {
    height: 1.2rem!important;
    padding: 0!important;
    /*overflow-x: hidden;*/
  }
  .el-footer{
    height:1rem!important;
    padding: 0!important;
  }
  .el-main {
    padding: 0!important;
    min-height:calc(100vh - 2.2rem);
  }

</style>



// WEBPACK FOOTER //
// src/pages/main.vue